import React from 'react';
import { useRecoilValue } from 'recoil';
import { blockInfoGraphicType, isReportState } from 'venn-state';

import { BaseGrid } from '../../components/visualizations/grids/base-grid';
import { useAppPrintMode } from '../../../print';
import { useCommonTreeGridProps } from '../../../studio-blocks/logic/columnUtils';
import ExportableGrid from '../../../studio-blocks/components/grid/ExportableGrid';
import { autoGroupColumnDefStaticConstants } from '../../../studio-blocks/components/grid/AgGridThemeOverrides';
import { treeGridColDefOverrides } from '../../utils';

import { useFinancialPerformanceIndicatorsData } from './logic/useFinancialPerformanceIndicatorsData';
import { useFinancialPerformanceIndicatorsTable } from './logic/useFinancialPerformanceIndicatorsTable';
import { useFinancialPerformanceIndicatorsTreeTable } from './logic/useFinancialPerformanceIndicatorsTreeTable';

export const FinancialPerformanceIndicatorsContent = ({ id }: { id: string }) => {
  const infoGraphicType = useRecoilValue(blockInfoGraphicType(id));

  if (infoGraphicType === 'GRID') {
    return <Grid id={id} />;
  }

  if (infoGraphicType === 'PIVOTED_GRID') {
    return <PivotedGrid id={id} />;
  }

  return null;
};

const PivotedGrid = ({ id }: { id: string }) => {
  const { inPrintModeOrReportLab } = useAppPrintMode();

  const data = useFinancialPerformanceIndicatorsData(id);
  const { rowData, columnDefs } = useFinancialPerformanceIndicatorsTreeTable(id, data);

  const treeGridProps = useCommonTreeGridProps(treeGridColDefOverrides);

  return (
    <ExportableGrid
      {...treeGridProps}
      selectedRefId={id}
      inPrintMode={inPrintModeOrReportLab}
      rowData={rowData}
      columnDefs={columnDefs}
      exportable={false}
      isCompact={false}
      autoGroupColumnDef={autoGroupColumnDefStaticConstants}
    />
  );
};

const Grid = ({ id }: { id: string }) => {
  const { inPrintModeOrReportLab } = useAppPrintMode();
  const isReport = useRecoilValue(isReportState);

  const data = useFinancialPerformanceIndicatorsData(id);
  const { rowData, columnDefs } = useFinancialPerformanceIndicatorsTable(id, data);

  return (
    <BaseGrid
      selectedRefId={id}
      inPrintMode={inPrintModeOrReportLab}
      rowData={rowData}
      columnDefs={columnDefs}
      isReport={isReport}
      exportable={false}
      isCompact={false}
    />
  );
};
